import React from "react";
import { AutocompleteDropdown } from "@vernost_dev/vms-react-components/dist/AutoCompleteDropDown";



const VmsAutocompleteDropdown = (props) => {
  const {
    items,
    isDropdown,
    renderMenu,
    showUpDownIcon,
    onSelect,
    value,
    renderItem,
    onChange = () => { },
    rightView,
    open,
    onMenuVisibilityChange = () => { },
    inputProps = {},
    label,
    secondPlaceHolder,
    additionalClassName,
    disabled=false
  } = props;

  return (
    <AutocompleteDropdown
      items={items}
      renderMenu={renderMenu}
      renderItem={renderItem}
      isDropdown={isDropdown}
      showUpDownIcon={showUpDownIcon}
      onSelect={onSelect}
      onChange={onChange}
      value={value}
      rightView={rightView}
      open={open}
      inputProps={inputProps}
      onMenuVisibilityChange={onMenuVisibilityChange}
      label={label}
      secondPlaceHolder={secondPlaceHolder}
      additionalClassName={additionalClassName}
      disabled={disabled}
    />

  );
};

export { VmsAutocompleteDropdown };
